import { SxProps, Theme } from '@mui/material/styles';

export const containerDpCarouselContenSecondarytSX: SxProps<Theme> = {
	userSelect: 'none',
	display: 'inline-flex',
	height: {
		xs: 'auto',
		sm: '500px',
	},
	backgroundColor: '#FFF',
};

export const containerDpCarouselContenMainSX = (mobile: boolean): SxProps<Theme> => ({
	userSelect: 'none',
	display: mobile ? { xs: 'flex', md: 'none' } : { xs: 'none', md: 'flex' },
	backgroundColor: '#FFF',
	height: '100%',
	position: 'relative',
});

export const containerInfoDpCarouselContenSecondarytSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	height: {
		xs: '200px',
		sm: '500px',
	},
	width: {
		xs: '100wv',
		sm: '400px',
	},
	p: {
		xs: '8px 30px 0 30px',
		sm: '0 70px 0 37px',
	},
};

export const containerInfoDpCarouselContentMainSX: SxProps<Theme> = {
	position: 'absolute',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: {
		xs: 'end',
		sm: 'center',
	},
	alignItems: 'start',
	height: '100%',
	p: {
		xs: '8px 20px 50px 20px',
		sm: '0 70px 0 37px',
	},
};

export const containerButtonsCarouselContenSecondarytSX: SxProps<Theme> = {
	display: 'inline-flex',
	justifyContent: {
		xs: 'center',
		sm: 'start',
	},
};
